<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
          label-position="top"
          size="large"
          :model="form"
          :rules="rules"
          ref="formRef"
        >
          <el-row>
            <el-col
              :xs="24"
              :sm="18"
              :lg="16"
              :xl="14"
              v-if="$store.state.role === 'admin'"
            >
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.region_id"
                  @change="getDistricts"
                  :loading="regionsLoading"
                >
                  <el-option
                    v-for="region in regions"
                    :key="region.id"
                    :value="region.id"
                    :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="18"
              :lg="16"
              :xl="14"
              v-if="$store.state.role === 'admin'"
            >
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.district_id"
                  :loading="districtsLoading"
                >
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :value="district.id"
                    :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Yil" prop="year">
                <el-select
                  v-model="form.season"
                  style="width: 100%"
                  placeholder="Yilni tanlang"
                >
                  <el-option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                    :label="year"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="Chorak" prop="quarter">
                <el-select
                  v-model="form.quarter"
                  style="width: 100%"
                  placeholder="Chorakni tanlang"
                >
                  <el-option
                    v-for="season in seasons"
                    :value="season"
                    :key="season"
                    :label="season"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Fayl" prop="file">
                <el-upload
                  ref="uploadRef"
                  class="upload-demo"
                  :auto-upload="false"
                  :multiple="false"
                  accept="application/pdf"
                  v-model:file-list="file"
                  :limit="1"
                  :on-exceed="onExceed"
                  :on-error="onErrorUpload"
                >
                  <template #trigger>
                    <el-button type="primary">Faylni tanlang</el-button>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item>
                <el-button @click="onFileUpload">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification, ElMessage } from "element-plus";

export default {
  name: "QuartertBudgetForm",
  data() {
    return {
      regionsLoading: false,
      districtsLoading: false,
      regions: [],
      districts: [],
      loading: false,
      form: {
        region_id: null,
        district_id: null,
        season: 2025,
        quarter: 1,
        file_id: null,
      },
      years: [2020, 2021, 2022, 2023,2024,2025,2026],
      seasons: [1, 2, 3, 4],
      file: [],

      rules: {
        district_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        region_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getSingle();
    }
    this.getRegions();
  },
  methods: {
    beforeUploadFile(rawFile) {
      console.log(rawFile.type);
      if (!rawFile) {
        return false;
      }
      if (rawFile.type !== "application/pdf") {
        ElMessage.error(`Iltimos pdf fayl yuklang!`);
        return false;
      }
      return true;
    },
    getSingle() {
      console.log(this.$route.params);

      this.loading = true;
      this.$http
        .get("/api/v1/quarterly-reports/" + this.$route.params.id)
        .then(({ data }) => {
          console.log(data);
          this.form = data;
          this.getDistricts();
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
          if (!this.$route.params.id) {
            this.form.district_id = null;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: this.form.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },

    onFileUpload() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.file.length > 0) {
            this.uploadFile();
          } else if (this.form.file_id) {
            this.onSubmit();
          } else {
            ElNotification.error({
              message: "Fayl tanlanmagan!",
            });
          }
        }
      });
    },

    uploadFile() {
      const result = this.beforeUploadFile(this.file[0].raw);
      if (!result) return;
      const formData = new FormData();
      formData.append("file", this.file[0]?.raw);

      this.loading = true;
      this.$http
        .post(
          `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          this.form.file_id = res.data.hashId;
          this.onSubmit();
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: this.$route.params.id
              ? `${process.env.VUE_APP_BASE_API_URL}api/v1/quarterly-reports/${this.$route.params.id}`
              : `${process.env.VUE_APP_BASE_API_URL}api/v1/quarterly-reports`,
            data: this.form,
            method: this.$route.params.id ? "put" : "post",
          })
            .then(() => {
              ElNotification.success({
                message: "Amaliyot muvaffaqiyatli bajarildi!",
              });
              this.$router.push({ name: "QuarterReports" });
            })
            .catch((error) => {
              console.log(error, "error");
              ElNotification.error({
                message:
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    onExceed(files) {
      console.log(files, "filesss");
      this.file[0] = files[0];
    },
    onErrorUpload(error) {
      console.log(error, "error occured");
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 20px;
}

.upload-demo {
  width: 100%;
}
</style>
